<template>
  <div class="pay-info style01">
    <div class="pay-heading">
      <strong class="heading">
        <i class="icon-add mr-1"></i> <span>{{ product.product.addon_name }}</span>
      </strong>
      <strong class="price price-addon" v-if="product.product.free !== '1'">
        {{ currency }}{{ product.product.full_price }}<span v-if="product.quantity > 1" class="addons-multiple">x{{ product.quantity }}</span>
      </strong>
      <strong class="price price-addon" v-else>
        {{ $t('payment.basket.free') }}
      </strong>
    </div>

    <!-- booking fee === addon_id 2 and used addon_info -->
    <p v-if="product.product.upsell_info.length > 0 || product.product.addon_id === '2'">
      {{ product.product.upsell_info || product.product.addon_info }}
    </p>
  </div>
</template>

<script>
import mixins from "@/mixins";

export default {
  name: "basket-addon-item",
  mixins: [mixins.globals],
  props: {
    product: { required: true, default: () => {} }
  }
};
</script>